(function(){
  var btns = document.querySelectorAll('.ewg-faq-btn');
  function setOpen(btn, open){
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if(!panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var sign = btn.querySelector('.ewg-faq-sign');
    if(sign) sign.textContent = open ? '\u2212' : '+';
    if(open){ panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden',''); }
  }
  Array.prototype.forEach.call(btns, function(btn){
    btn.addEventListener('click', function(){
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      Array.prototype.forEach.call(btns, function(b){ setOpen(b, false); });  // single-open, matches the design
      if(!isOpen) setOpen(btn, true);
    });
  });
})();
